import { getCurrentConnectedWallet, setCurrentConnectedWallet, setWeb3Sender, WALLET_IDS } from "..";
import { resetAccountState } from "../../../redux/slices/account/account-slice";
import { INFO_TOP_CENTER } from "../../../utils/snackbar-utils";
import { clearMetaMaskEventListeners } from "./metamask";
import { clearWalletConnectEventListeners, provider } from "./wallet-connect";

export function disconnectCurrentWallet(dp, eq) {
  const currentConnectedWallet = getCurrentConnectedWallet();

  if (currentConnectedWallet === WALLET_IDS.METAMASK) {
    clearMetaMaskEventListeners();
  } else if (currentConnectedWallet === WALLET_IDS.WALLET_CONNECT) {
    provider.disconnect();
    clearWalletConnectEventListeners();
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
  window.localStorage.removeItem("jwtToken");
  window.localStorage.removeItem("refreshToken");
  dp(resetAccountState());
  setWeb3Sender(null);
  setCurrentConnectedWallet(null);
  eq("Disconnected", INFO_TOP_CENTER);
}
